import { PDColor } from './PDModal';

export const MEDIA_WIDTH = 480;
export const MEDIA_HEIGHT = 480;

export const MEDIA_STEAM_CONSTRAINTS = {
  audio: false,
  video: {
    width: { ideal: MEDIA_WIDTH },
    height: { ideal: MEDIA_HEIGHT },
    aspectRatio: {
      ideal: 1
    },
    facingMode: 'user'
  }
};

export const LENS_COLOR_MAP: PDColor[] = [
  {
    id: 'grey',
    hex: '#2D2D2D',
    title: 'Grey',
    keyword: 'grey',
    defaultTreatType: 'uvtint',
    disabledRegions: []
  },
  {
    id: 'brown',
    hex: '#8E5000',
    title: 'Brown',
    keyword: 'brown',
    defaultTreatType: 'uvtint',
    disabledRegions: []
  },
  {
    id: 'mirror-silver',
    hex: '#777777',
    title: 'Mirror Silver',
    keyword: 'silver',
    defaultTreatType: 'mirror',
    disabledRegions: ['nz']
  },
  {
    id: 'mirror-blue',
    hex: '#ADD8E6',
    title: 'Mirror Blue',
    keyword: 'blue',
    defaultTreatType: 'mirror',
    disabledRegions: ['nz']
  }
];

// reverse color of color picker checkmark icon on selected
export const LIGHT_COLORS = ['white', 'clear'];
